/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum DocumentFetcherType {
  Api = "API",
  WebScraping = "WEB_SCRAPING",
  EdiSftp = "EDI_SFTP",
}

export function instanceOfDocumentFetcherType(value: any): boolean {
  for (const key in DocumentFetcherType) {
    if (Object.prototype.hasOwnProperty.call(DocumentFetcherType, key)) {
      if (
        DocumentFetcherType[key as keyof typeof DocumentFetcherType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function DocumentFetcherTypeFromJSON(json: any): DocumentFetcherType {
  return DocumentFetcherTypeFromJSONTyped(json, false);
}

export function DocumentFetcherTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentFetcherType {
  return json as DocumentFetcherType;
}

export function DocumentFetcherTypeToJSON(
  value?: DocumentFetcherType | null,
): any {
  return value as any;
}

export function DocumentFetcherTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DocumentFetcherType {
  return value as DocumentFetcherType;
}
